export class RelationArticleGroup {
  id: number;
  name: string;
  description: string;
  active: boolean;
}
